'use strict'

var Type = require('../type')

module.exports = Type({
  name: 'Diners Club',
  pattern: /^3(0[0-5]|[68]\d)\d{11}$/,
  eagerPattern: /^3(0|[68])/,
  groupPattern: /(\d{1,4})?(\d{1,6})?(\d{1,4})?/
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/types/diners-club.js
// module id = 39J6
// module chunks = 0